import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const { idTab } = attributes;

  const allowedBlocksPlans = [
    'plans-company/block',
    'app/plans-corporate',
    'app/grid-cards',
  ];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`TabsCompany__container TabsCompany__editor`} id={idTab}>
        <InnerBlocks allowedBlocks={allowedBlocksPlans} />
      </div>
    </>
  );
};
